module.exports = __webpack_public_path__ + "src/assets/sample-import-files/sample-product.xlsx";